import { useCallback } from 'react'

function useTracker() {
  const trackEvent = useCallback((name, eventData = {}, options = {}) => {
    if (typeof window !== 'undefined' && window.customEventTracker) {
      window.customEventTracker({ name, eventData, ...options })
      return
    }

    // SSR or GTM not loaded: invoke eventCallback synchronously so callers that
    // gate navigation on it (e.g., SubscribeButton) do not stall on the safety timeout.
    options.eventCallback?.()
  }, [])

  return { trackEvent }
}

export default useTracker
